export const AmortizationTopic = {
  INVESTIMENT_PROPERTY: 'INVESTIMENT_PROPERTY',
  TANGIBLE_ASSETS: 'TANGIBLE_ASSETS',
  INTANGIBLE_ASSETS: 'INTANGIBLE_ASSETS',

  values: () => {
    return ['INVESTIMENT_PROPERTY', 'TANGIBLE_ASSETS', 'INTANGIBLE_ASSETS'];
  }
};
